import React from 'react';
import './Help.css';

function Help() {
  return (
    <div className="help-container">
      <div className="help-header">
        <h1>Help Center</h1>
        <p>Find answers and get support</p>
      </div>
      
      <div className="help-content">
        <div className="help-section">
          <h2>Getting Started</h2>
          <div className="help-links">
            <a href="/help/quickstart">Quick Start Guide</a>
            <a href="/help/tutorial" className="no-right-click">Interactive Tutorial</a>
            <a href="/help/setup" data-no-context="true">Setup Instructions</a>
          </div>
        </div>
        
        <div className="help-section">
          <h2>Documentation</h2>
          <div className="help-links">
            <a href="/docs/api">API Reference</a>
            <a href="/docs/guides">User Guides</a>
            <a href="/docs/examples" className="exclude-menu">Code Examples</a>
            <a href="/docs/troubleshooting">Troubleshooting</a>
          </div>
        </div>
        
        <div className="help-section">
          <h2>Support Resources</h2>
          <div className="help-links">
            <a href="/support/tickets">Support Tickets</a>
            <a href="/support/chat" className="no-right-click">Live Chat</a>
            <a href="/support/phone" data-exclude-context="true">Phone Support</a>
            <a href="/support/email">Email Support</a>
          </div>
        </div>
        
        <div className="help-section">
          <h2>Community</h2>
          <div className="help-links">
            <a href="https://forum.example.com" target="_blank" rel="noopener noreferrer">Community Forum</a>
            <a href="https://discord.gg/example" target="_blank" rel="noopener noreferrer" className="exclude-menu">Discord Server</a>
            <a href="https://reddit.com/r/example" target="_blank" rel="noopener noreferrer">Reddit Community</a>
            <a href="/community/events" data-no-context="true">Community Events</a>
          </div>
        </div>
      </div>
      
      <div className="help-footer">
        <p>Still need help? <a href="/contact" className="no-right-click">Contact our support team</a></p>
      </div>
    </div>
  );
}

export default Help;
